import React from "react";

import { createBrowserRouter, Navigate } from "react-router-dom";
// pages

import LandingV02 from "./Pages/LandingV02";
import Signup from "./Pages/Auth/Signup";
import Login from "./Pages/Auth/Login";
import VerifyEmail from "./Pages/Auth/VerifyEmail";
import ResetPassword from "./Pages/Auth/ResetPassword";
import NoRoute from "./Pages/NoRoute";
import WeddingInvitationTemplates from "./Pages/Templates/WeddingInvitationTemplates/WeddingInvitationTemplates";
import WeddingInvitation from "./Pages/Invitations/WeddingInvitations";
import ManageWeddingInvitations from "./Pages/Invitations/ManageWeddingInvitations";
import Dashboard from "./Pages/Invitations/Dashboard";
import MyAccount from "./Pages/MyAccount";
import Personal from "./Pages/MyAccount/Personal";
import MyInvitations from "./Pages/MyAccount/MyInvitations";
import Security from "./Pages/MyAccount/Security";
import Admin from "./Pages/Admin";
import AdminOverview from "./Pages/Admin/Overview";
import AdminInvitations from "./Pages/Admin/InvitationsList";
import AdminOrders from "./Pages/Admin/Orders";
import AdminTransactions from "./Pages/Admin/Transactions";
import AdminAffiliate from "./Pages/Admin/Affiliate";
import InvitationAlbum from "./Pages/Invitations/Album";
import WeddingTemplates from "./Pages/WeddingTemplates";
import AboutUs from "./Pages/AboutUs";
import Features from "./Pages/Features";

//components
import AppWrapper from "./Components/AppWrapper";
import AuthRoute from "./Components/AuthRoute";
import AdminRoute from "./Components/AdminRoute";
import AppRoot from "./Components/AppRoot";
import VerificationCompleted from "./Pages/VerficationCompleted";
import ScrollToTop from "./Components/ScrollToTop";
import Overview from "./Pages/Invitations/Dashboard/Overview";
import RSVP from "./Pages/Invitations/Dashboard/RSVP";
import Memories from "./Pages/Invitations/Dashboard/Memories";
import DashboardSettings from "./Pages/Invitations/DashboardSettings";
import ContactUs from "./Pages/ContactUs";
import HowitWorks from "./Pages/HowItWorks";
import PaymentCallback from "./Pages/Invitations/PaymentCallback";
import RefundPolicy from "./Pages/RefundPolicy";
import AffiliateRules from "./Pages/AffiliateRules";
import Orders from "./Pages/MyAccount/Orders";
import Transactions from "./Pages/MyAccount/Transactions";
import Affiliate from "./Pages/MyAccount/Affiliate";
import PrivacyPolicy from "./Pages/PrivacyPolicy";
import TermsAndConditions from "./Pages/TermsAndConditions";
import Pricing from "./Pages/Pricing";
import ActivateAffiliate from "./Pages/ActivateAffiliate";
import { PaddlePaymentCallback } from "./Pages/Invitations/PaymentCallback/PaddlePaymentCallback";

export const router = createBrowserRouter([
	{
		element: (
			<AppRoot>
				<AppWrapper />
				<ScrollToTop />
			</AppRoot>
		),
		errorElement: <NoRoute />,
		children: [
			{
				path: "/",
				Component: LandingV02
			},
			{ path: "/invitation-templates", Component: WeddingTemplates },
			{ path: "/pricing", Component: Pricing },
			{ path: "/features", Component: Features },
			{ path: "/aboutus", Component: AboutUs },
			{ path: "/contactus", Component: ContactUs },
			{ path: "/howitworks", Component: HowitWorks },
			{ path: "/refund-policy", Component: RefundPolicy },
			{ path: "/affiliate-policy", Component: AffiliateRules },
			{ path: "/privacy-policy", Component: PrivacyPolicy },
			{ path: "/terms-and-conditions", Component: TermsAndConditions },
			{ path: "/signup", Component: Signup },
			{ path: "/login", Component: Login },
			{ path: "/resetPassword", Component: ResetPassword },
			{
				path: "/verifyEmail",
				Component: VerifyEmail
			},
			{
				path: "/verification/email",
				Component: VerificationCompleted
			},
			{
				path: "/weddingInvitation/:id",
				Component: WeddingInvitationTemplates
			},
			{
				path: "/weddingInvitation/:id/memories",
				Component: InvitationAlbum
			},
			{
				element: <AuthRoute />,
				children: [
					{
						path: "/activateAffiliate",
						Component: ActivateAffiliate
					},
					{
						path: "/myAccount",
						Component: MyAccount,
						children: [
							{ index: true, element: <Navigate to="invitations" replace /> },
							{
								path: "personal",
								Component: Personal
							},
							{
								path: "security",
								Component: Security
							},
							{
								path: "invitations",
								Component: MyInvitations
							},
							{
								path: "orders",
								Component: Orders
							},
							{
								path: "transactions",
								Component: Transactions
							},
							{
								path: "affiliate",
								Component: Affiliate
							}
						]
					},
					{
						path: "/manageWeddingInvitation",
						Component: ManageWeddingInvitations,
						children: [
							{
								path: ":id",
								Component: WeddingInvitation
							},
							{
								path: ":id/dashboard",
								Component: Dashboard,
								children: [
									{ index: true, element: <Navigate to="overview" replace /> },
									{ path: "overview", Component: Overview },
									{ path: "rsvp", Component: RSVP },
									{ path: "memories", Component: Memories },
									{ path: "settings", Component: DashboardSettings }
								]
							}
						]
					},
					{
						path: "/paymentCallback/invitation/:id",
						Component: PaymentCallback
					},
					{
						path: "/paddlePaymentCallback/invitation/:id",
						Component: PaddlePaymentCallback
					}
				]
			},
			{
				element: <AdminRoute />,
				children: [
					{
						path: "/admin",
						Component: Admin,
						children: [
							{ index: true, element: <Navigate to="overview" replace /> },
							{ path: "overview", Component: AdminOverview },
							{ path: "invitations", Component: AdminInvitations },
							{ path: "orders", Component: AdminOrders },
							{ path: "transactions", Component: AdminTransactions },
							{ path: "affiliate", Component: AdminAffiliate }
						]
					}
				]
			}
		]
	}
]);
